import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AccountDetails } from "@WhiteCap/Store/Service/AccountDetails";

import { Draft } from "immer";

export interface AccountDetailsState {
    isLoading: boolean;
    AccountInformation?: AccountDetails;
}

const initialState: AccountDetailsState = {
    isLoading: false,
    AccountInformation: undefined,
};
const AccountDetailsReducer = {
    "Custom/AccountDetails/BeginLoadAccountData": (draft: Draft<AccountDetailsState>) => {
        draft.isLoading = true;
    },
    "Custom/AccountDetails/CompletedLoadAccountData": (
        draft: Draft<AccountDetailsState>,
        action: {
            result: AccountDetails;
        },
    ) => {
        draft.AccountInformation = action.result;
        draft.isLoading = false;
    },
    "Custom/AccountDetails/Reset": () => {
        return initialState;
    },
};

export default createTypedReducerWithImmer(initialState, AccountDetailsReducer);
